// extracted by css-extract-rspack-plugin
export default {"root":"root-frdFcf","grid":"grid-OWHFbN","item":"item-_o8ozM","icon":"icon-UXNITb","label":"label-GteGqh"};